import { useState } from "react";
import TemplateUpload from "./components/TemplateUpload";
import RevenueTransaction from "./components/RevenueTransaction";
import Dropdown from "../../components/dropdown/Index";
import useMallTenantDropdown from "../../hooks/useMallTenantDropdown";
import { triggerTenantChange } from "../../utils/tenantChangeEvent";

export default function Index() {
  const [activeTab, setActiveTab] = useState("template");
  const {
    mallOptions,
    tenantOptions,
    selectedMall,
    selectedTenant,
    setSelectedMall,
    setSelectedTenant,
  } = useMallTenantDropdown(() => {
    triggerTenantChange();
  });

  const tabs = [
    {
      id: "template",
      label: "Upload",
      content: <TemplateUpload />,
    },
    {
      id: "revenue",
      label: "Input Manual",
      content: <RevenueTransaction />,
    },
  ];

  return (
    <>
      <Dropdown
        mallSelected={setSelectedMall}
        mallOptions={mallOptions}
        tenantSelected={setSelectedTenant}
        tenantOptions={tenantOptions}
        mallValue={selectedMall}
        tenantValue={selectedTenant}
      />
      <div className="bg-white rounded-xl dark:bg-gray-900 p-6">
        <div className="mb-4 md:flex md:justify-between">
          <ul className="flex flex-wrap -mb-px text-sm font-medium text-center">
            {tabs.map((tab) => (
              <li key={tab.id} className="me-2">
                <button
                  className={`inline-block font-semibold rounded-xl p-3 border transition-colors duration-200 ${activeTab === tab.id
                    ? "bg-blue-600 text-white border-blue-700"
                    : "bg-white text-gray-800 border-gray-200 hover:text-gray-900 hover:border-gray-300"
                    }`}
                  onClick={() => setActiveTab(tab.id)}
                  type="button"
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>


        </div>

        <div className="tab-content">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={` rounded-lg transition-opacity duration-300 ${activeTab === tab.id ? "block" : "hidden"
                }`}
            >
              <main className="text-sm text-gray-500">
                {activeTab === tab.id && tab.content}
              </main>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

